import { Link } from "react-router-dom";
import { BetaSignupDialog } from "@/Forms";
import { Map, LifeBuoy, ShieldCheck, GitCompare, Rocket, Menu, X } from "lucide-react";
import { useState } from "react";

const LINKS = [
  { to: "/roadmap", label: "Roadmap", icon: Map, testid: "nav-roadmap" },
  { to: "/compare", label: "Compare Apps", icon: GitCompare, testid: "nav-compare" },
  { to: "/support", label: "Support", icon: LifeBuoy, testid: "nav-support" },
  { to: "/security", label: "Security", icon: ShieldCheck, testid: "nav-security" },
];

export const NavBar = () => {
  const [open, setOpen] = useState(false);
  return (
    <header
      data-testid="site-nav"
      className="sticky top-0 z-50 backdrop-blur-md bg-[#08101d]/80 border-b border-white/10"
    >
      <div className="max-w-6xl mx-auto px-5 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-home" className="flex items-center gap-2.5">
          <img src="/favicon.png" alt="Herrell Interactive" className="w-8 h-8 rounded-md" />
          <span className="hi-serif text-[#f3ead4] tracking-wide text-sm sm:text-base">HERRELL INTERACTIVE</span>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={l.testid}
              className="hi-body text-sm text-white/70 hover:text-white px-3 py-2 rounded-lg hover:bg-white/5 transition-colors"
            >
              {l.label}
            </Link>
          ))}
          <BetaSignupDialog
            trigger={
              <button
                data-testid="nav-join-beta"
                className="hi-cta ml-2 inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-bold hi-body bg-gradient-to-r from-[#1f5fbf] to-[#3b9bff] text-white hover:brightness-110"
              >
                <Rocket size={15} strokeWidth={2.5} /> Join the Beta
              </button>
            }
          />
        </nav>

        <button
          className="md:hidden text-white/80"
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((o) => !o)}
          aria-label="Menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/10 bg-[#08101d]/95 px-5 py-4 space-y-1" data-testid="nav-mobile">
          {LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              onClick={() => setOpen(false)}
              className="hi-body flex items-center gap-2 text-white/80 hover:text-white px-3 py-2.5 rounded-lg hover:bg-white/5"
            >
              <l.icon size={16} /> {l.label}
            </Link>
          ))}
          <BetaSignupDialog
            trigger={
              <button className="hi-cta w-full mt-2 inline-flex items-center justify-center gap-2 rounded-full px-4 py-2.5 text-sm font-bold hi-body bg-gradient-to-r from-[#1f5fbf] to-[#3b9bff] text-white">
                <Rocket size={15} strokeWidth={2.5} /> Join the Beta
              </button>
            }
          />
        </div>
      )}
    </header>
  );
};

export default NavBar;
